/*=================服务地址===================*/
// 本地环境
// export const  serviceUrl = "http://localhost:8100"
// export const  serviceWebUrl = "http://localhost:8101"

// 测试环境
// export const  serviceUrl = "http://39.101.177.240:8100"
// export const  serviceWebUrl = "http://39.101.177.240:8101"

// 生产环境 jingzhunjy
export const  serviceUrl = "https://www.jingzhunjy.com"
export const  serviceWebUrl = "https://www.jingzhunjy.com"


/*===========OSS配置===========*/
let OSS = require('ali-oss');
export let ossClient = new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAI5tCqpy6gH2Kfn5F7mS7H',
    accessKeySecret: 'aVdDcMLLrcWYW5WBePRglyd3oqNIF1',
    bucket: 'free-back'
})

